<div class="top-card-container">
  <div class="top-card">
    <div class="badge-container">
      <span class="badge">{{'MAIN.COMING_EARLY_2025' | translate}}</span>
    </div>
    <h1 class="title" [innerHTML]="title | translate"></h1>
    <p class="descr">{{descr | translate}}</p>

    <form [formGroup]="subscriprionForm" class="action-container" (ngSubmit)="submitForm()">
      <ng-container *ngIf="!(successRequest$ | async); else successBlock">
        <div class="form-control">
          <input class="input-control dark"
                 appAutoFocus
                 type="text"
                 formControlName="email"
                 [placeholder]="'MAIN.ENTER_E_MAIL' | translate"
                 [class.error]="
        subscriprionForm.controls?.email?.invalid &&
        ((subscriprionForm.controls?.email?.touched && subscriprionForm.controls?.email?.dirty) || checkedValidControl)"
          >
        </div>

        <button type="submit" class="btn btn-md" aria-label="Subscribe">
          {{'MAIN.SUBSCRIBE' | translate}}
          <img ngSrc="assets/img/arrow-small-right-white.svg" height="24" width="24" alt="">
        </button>
      </ng-container>
    </form>


    <div class="img-container">
      <picture *ngIf="!!img; else primaryImage">
        <source media="(max-width: 799px)" [srcset]="{en: img.en, de: img.de, at: img.at} | imagesByLocale: img.folder">
        <source media="(min-width: 800px)" [srcset]="{en: img.en, de: img.de, at: img.at} | imagesByLocale: img.folder">
        <img class="w-full" height="880" width="1440" [ngSrc]="{en: img.en, de: img.de, at: img.at} | imagesByLocale: img.folder" alt="">
      </picture>
    </div>
  </div>
</div>

<ng-template #successBlock>
  <app-success-block></app-success-block>
</ng-template>

<ng-template #primaryImage>
  <picture>
    <source media="(max-width: 799px)" [srcset]="{en: 'Point_of_sale=en@2.webp', de: 'Point_of_sale=de@2.webp', at: 'Point_of_sale=de@2.webp'} | imagesByLocale: 'point-of-sale'">
    <source media="(min-width: 800px)" [srcset]="{en: 'Point_of_sale=en@2.webp', de: 'Point_of_sale=de@2.webp', at: 'Point_of_sale=de@2.webp'} | imagesByLocale: 'point-of-sale'">
    <!--        <img class="w-full" height="880" width="1440" [ngSrc]="{en: 'Point_of_sale=en@2.webp', de: 'Point_of_sale=de@2.webp', at: 'Point_of_sale=de@2.webp'} | imagesByLocale: 'point-of-sale'" alt="Point of sale" loading="lazy">-->
    <img class="w-full" height="880" width="1440" [ngSrc]="{en: 'Point_of_sale=en@2.webp', de: 'Point_of_sale=de@2.webp', at: 'Point_of_sale=de@2.webp'} | imagesByLocale: 'point-of-sale'" alt="Point of sale">
  </picture>
</ng-template>
